
$(function(){

    let mapBounds = new google.maps.LatLngBounds();
    let markers = [];
    let depotPopupsHeight = 0;

    const setMapMinHeight = function() {

        if (window.innerWidth >= 1024) {

            $("#depot-finder-popups > li").each(function() {
                if ($(this).height() > depotPopupsHeight) {
                    depotPopupsHeight = $(this).height();
                }                
            })    

            $("#depot-map").css("minHeight", depotPopupsHeight + 100);

        } else {
            $("#depot-map").css("minHeight", 0);
        }    
    }

    if ($("#depot-map").length) {
        const depotMap = new google.maps.Map(document.getElementById("depot-map"), {
            center : {
                lat : 55.61004,
                lng : -2.36436
            },
            zoom : 12,
            minZoom : 5,
            disableDefaultUI : true,
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#444444"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "hue": "#ff0000"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": "100"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "lightness": "100"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.landcover",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.terrain",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": "100"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.terrain",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "off"
                        },
                        {
                            "lightness": "23"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffd900"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#ffd900"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#cccccc"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                }
            ]
        })

        $("#depot-finder-popups > li").each(function(i) {
            let newMarker = new google.maps.Marker({
                position : {
                    lat : parseFloat($(this).data("lat")),
                    lng : parseFloat($(this).data("lng"))
                },
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: "#FBBB2D",
                    fillOpacity: 1,
                    strokeWeight: 6,
                    scale: 10
                },
                map : depotMap,
                id : i
            });            

            newMarker.addListener("click", function() {
                $("#depot-finder-popups > li.active").removeClass("active");
                $("#depot-finder-popups > li").eq(this.id).addClass("active");                

                if ($("#depot-finder-popups").hasClass("child-open")) {
                    $("#depot-finder-popups").removeClass("child-open")
                } else {
                    $("#depot-finder-popups").addClass("child-open")
                }
            });

            markers.push(newMarker);
            
            mapBounds.extend(markers[i].getPosition());            
        });

        $("#depot-finder-popups li .close-depot-popup").on("click", function() {
            $("#depot-finder-popups").removeClass("child-open").find("li.active").removeClass("active");
        });

        //Fit bounds
        depotMap.fitBounds(mapBounds);

        //Initialise carousel for popups
        $(".depot-popup-carousel").flickity({
            prevNextButtons : false,
            pageDots : false,
            autoPlay : 3000,
            contain : true,
            draggable : true,
            wrapAround : $(".depot-popup-carousel .depot-carousel-item").length >= 4 ? true : false
        });

        setMapMinHeight();

        $(window).on("resize", setMapMinHeight)
    }

})
